module.exports = __webpack_public_path__ + "static/media/sedan.e93371d6.svg";